import EventsNonSportradarModel from './EventsNonSportradarModel';
import validate from './validator';
import {applyPresetArgosFieldsForModel, applyPresetFieldsForModel, presetFieldsForModel} from './EventModel';

export default function NonSportradarEventModel(isEdit = false) {
    const isEditModel = true === isEdit;
    const model = EventsNonSportradarModel();
    const presetFields = applyPresetFieldsForModel(isEditModel);
    const presetArgosFields = applyPresetArgosFieldsForModel(isEditModel);

    model.fields.event_preset = presetFields.event_preset;

    if (isEditModel) {
        model.fields.as_additional_contents = presetFields.as_additional_contents;
        model.fields.as_additional_argos = presetArgosFields.as_additional_argos;
    }

    model.validate = validate;

    delete model.fields.multiple[0].description.props.required;
    delete model.fields.end_datetime.props.required;

    model.fields = {...model.fields, ...presetFieldsForModel()};

    return model;
}
